import React, { useState } from 'react'
import { DropDownTabsCSS } from './DropDownTabsCSS.styled'
import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'

export const DropDownTabs = ({ tabs, onSelect, activeTabId }) => {
  const [selectedTabId, setSelectedTabId] = useState(activeTabId || tabs[0].id)

  const optionClickHandler = (id) => {
    setSelectedTabId(id)
    onSelect(id)
  }

  const selectableTabs = tabs.filter((tab) => tab.id !== selectedTabId)

  const isReactComponent = (content) => {
    return React.isValidElement(content)
  }

  return (
    <DropDownTabsCSS>
      <div className='select-box'>
        <div
          className={`select-box__current ${isReactComponent(tabs[selectedTabId].content) ? 'component' : ''}`}
          tabindex='1'
        >
          <div className='select-box__value'>
            <input
              className='select-box__input'
              type='radio'
              id='bidding_table'
              value='1'
              name='asset_selection_graph-header'
              checked='checked'
            />
            <p className='select-box__input-text'>{tabs[selectedTabId].content} </p>
          </div>

          <div className='menu_select'></div>
        </div>
        <ul className='select-box__list'>
          {selectableTabs.map((tab) => (
            <li onClick={() => optionClickHandler(tab.id)}>
              <SingleContentToggle
                noWrapper
                toggle={isReactComponent(tab.content)}
                trueContent={
                  <label className={`select-box__option ${isReactComponent(tab.content) ? 'component' : ''}`}>
                    {tab.content}
                  </label>
                }
                falseContent={<label className='select-box__option'>{tab.content}</label>}
              />
            </li>
          ))}
        </ul>
      </div>
    </DropDownTabsCSS>
  )
}
